import { Component, OnInit } from '@angular/core';
import { BaseModal } from 'src/app/shared/base-modal';
import { Area } from 'src/app/_models/area.model';
import { City } from 'src/app/_models/city.model';
import { FullPatient, PatientAddress } from 'src/app/_models/patient.model';
import { AreaService } from 'src/app/_services/area.service';
import { CityService } from 'src/app/_services/city.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PatientService } from 'src/app/_services/patient.service';

@Component({
  selector: 'app-add-new-address',
  templateUrl: './add-new-address.component.html',
  styleUrls: ['./add-new-address.component.scss']
})
export class AddNewAddressComponent extends BaseModal implements OnInit {
  cityList: City[];
  areaList: Area[];
  patient = {} as FullPatient;
  newAddress = {} as PatientAddress;
  loading = false;
  patientId;
  constructor(
    private cityService: CityService,
    private areaService: AreaService,
    protected modal: NgbActiveModal,
    private patientService: PatientService,
  ) {
    super(modal);
  }

  ngOnInit(): void {
    this.cityService.getAllCities().subscribe((res) => {
      this.cityList = res;
      // if (this.patient.personalInfo.cityId) {
      //   this.patient.personalInfo.cityName = this.cityList.find(
      //     (city) => city.id === this.patient.personalInfo.cityId
      //   )?.enName;
      // }
      // this.patient.addresses.map((address) => {
      //   address.cityName = this.cityList.find(
      //     (city) => city.id === address.cityId
      //   )?.enName;
      //   this.areaService
      //     .getStringAreaName(address.areaId)
      //     .subscribe((res) => {
      //       address.areaName = res.data.enName;
      //     });
      // });
    });
  }

  onCityChange(cityId, flag = true, address = null) {
    //

    if (cityId) {


      this.areaService.getAreasByCityId(cityId).subscribe((res) => {
        this.areaList = res?.data?.areas;
        if (flag) {
          this.newAddress.areaId = null;
        } else {
          this.newAddress = { ...address };
        }
        this.newAddress.cityId = cityId;
        this.newAddress.cityName = this.cityList.find(
          (city) => city.id === +cityId
        )?.enName;
        //
      });
    }
  }
  onAreaChange(areaId) {
    //
    if (areaId) {

      this.newAddress.areaId = areaId;
      this.newAddress.areaName = this.areaList.find(
        (area) => area.id === +areaId
      )?.enName
    }
  }

  onSubmit(): void {
    const body = { patientId: this.patientId, ...this.newAddress };


    this.patientService.addAddress(body).subscribe((res) => {
      if (res) {
        let addedAddress = {} as PatientAddress;
        addedAddress = { ...res.data };
        addedAddress.cityName = this.cityList.find(
          (city) => city.id === res.data.cityId
        )?.enName;
        addedAddress.areaName = this.areaList.find(
          (area) => area.id === res.data.areaId
        )?.enName;
        // this.patient.addresses.push(addedAddress);
        this.modal.close(addedAddress);
      }
      this.loading = false;

    });

  }

}
